import React, { useEffect, useState } from "react";
import { Container, Card } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import userPhoto from "../../../images/user.png";
import {
  MdAddPhotoAlternate,
  MdDelete,
  MdEdit,
  MdAssessment,
} from "react-icons/md";
import {
  Button,
  Input,
  Spin,
  Modal,
  Pagination,
  InputNumber,
  Select,
} from "antd";
import CountUp from "react-countup";
import {
  Message,
  ViewInput,
  InputTel,
  InputMask,
  HeaderTitle,
} from "../../../GlobalStyles";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { IconButton } from "@mui/material";

const { confirm } = Modal;

export default function AssociadosAdmin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  const [associados, setAssociados] = useState([]);
  const [users, setUsers] = useState([]);
  const [user_id, setUser_id] = useState("");
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [associadosTotal, setAssociadosTotal] = useState(0);

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [comission, setComission] = useState(0);
  const [cnpj, setCnpj] = useState("");
  const [cpf, setCpf] = useState("");
  const [photo, setPhoto] = useState("");
  const [page, setPage] = useState(0);

  useEffect(() => {
    listAssociados();
  }, [page, filterSearch]);

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers() {
    await api
      .get(`/users?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function listAssociados() {
    setLoading(true);
    await api
      .get(`/associates`)
      .then((response) => {
        setAssociados(response.data.associates);
        setAssociadosTotal(response.data.associatesTotal);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }
  async function createAndEditAssociado() {
    setIsLoadingModal(true);
    const data = new FormData();
    data.append("name", name);
    data.append("email", email.toLowerCase());
    if (password) {
      data.append("password", password);
    }
    data.append("phone_number", phone_number);
    data.append("city", city);
    data.append("state", state);
    data.append("comission", comission);
    data.append("cnpj", cnpj);
    data.append("user_id", user_id);
    data.append("cpf", cpf);
    data.append("type", "associado");

    if (photo && photo.name) {
      data.append("file", photo, photo.name);
    }

    if (id) {
      if (!name || !email || !comission) {
        return toast.warn("Preencha os campos obrigatórios");
      }
      api
        .put(`/associate/${id}`, data)
        .then(async (ok) => {
          toast.success("Associado editado com sucesso");
          listAssociados();
          setVisibleModal(false);
        })
        .catch(({ response }) => {
          if (response?.data?.message) {
            toast.warn(response.data.message);
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        });
    } else {
      if (!name || !email || !comission || !password) {
        toast.warn(
          "Preencha todos os campos obrigátorios para realizar o cadastro",
        );
      } else {
        await api
          .post(`/associate`, data)
          .then(async (ok) => {
            toast.success("Associado criado com sucesso");
            listAssociados();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response?.data?.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteAssociado(id) {
    await api
      .delete(`/associate/${id}`)
      .then(() => {
        toast.success("Associado excluído com sucesso");
        listAssociados();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <HeaderTitle>
        <h1>Associados</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          icon={<MdAssessment size={18} />}
          onClick={() => navigate("/admin/associados/relatorio")}
        >
          Relatório Geral
        </Button>
      </HeaderTitle>

      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={associadosTotal} />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ width: 300 }}>
              <p>Pesquisar</p>
              <Input.Search
                value={filter}
                onChange={(text) => setFilter(text.target.value)}
                placeholder="nome ou email"
                onSearch={(text) => {
                  setFilterSearch(text);
                  setPage(0);
                }}
                allowClear
                enterButton
              />
            </ViewInput>
            <Button
              type="primary"
              style={{
                borderRadius: 50,
                marginBottom: 5,
              }}
              onClick={() => {
                setId("");
                setName("");
                setEmail("");
                setPassword("");
                setPhone_number("");
                setUser_id("");
                setCity("");
                setState("");
                setComission(0);
                setCnpj("");
                setCpf("");
                setPhoto("");
                setVisibleModal(true);
              }}
            >
              Novo Associado
            </Button>
          </div>

          {associados.length === 0 && (
            <Message>Nenhum associado encontrado</Message>
          )}

          <div className="orders">
            {associados.map((item) => (
              <div className="order" key={item.id}>
                <img
                  src={item.photo ? item.photo_url : userPhoto}
                  alt={item.name}
                />
                <div className="infos">
                  <p>
                    <strong>{item.name}</strong>
                  </p>
                  <p style={{ color: "#666", fontSize: 12 }}>{item.email}</p>
                  <p style={{ color: "#666", fontSize: 12 }}>
                    {item.city} - {item.state}
                  </p>
                </div>
                <div className="actions">
                  <Button
                    type="primary"
                    onClick={() => navigate(`/admin/associado/${item.id}`)}
                  >
                    Ver Detalhes
                  </Button>
                  <Button
                    type="primary"
                    className="warning-button"
                    onClick={() => {
                      setId(item.id);
                      setName(item.name);
                      setEmail(item.email);
                      setPhone_number(item.phone_number || "");
                      setUser_id(item.user_id || "");
                      setCity(item.city || "");
                      setState(item.state || "");
                      setComission(item.comission || 0);
                      setCnpj(item.cnpj || "");
                      setCpf(item.cpf || "");
                      setPhoto({ photo_url: item.photo_url });
                      setPassword("");
                      setVisibleModal(true);
                    }}
                  >
                    <MdEdit color="#FFF" size={18} /> Editar
                  </Button>
                  <Button
                    type="primary"
                    className="delete-button"
                    onClick={() => {
                      confirm({
                        okText: "Confirmar",
                        title: `Deseja excluir o Associado ${item.name}?`,
                        icon: <ExclamationCircleFilled />,
                        content: `Esta ação não pode ser desfeita.`,
                        onOk() {
                          deleteAssociado(item.id);
                        },
                        cancelText: "Cancelar",
                      });
                    }}
                  >
                    <MdDelete color="#FFF" size={18} /> Excluir
                  </Button>
                </div>
              </div>
            ))}
          </div>

          <Pagination
            style={{ margin: "25px 0", alignSelf: "center" }}
            current={page + 1}
            pageSize={30}
            onChange={(p) => setPage(p - 1)}
            total={associadosTotal}
          />
        </>
      )}

      <Modal
        title={id ? "Editar Associado" : "Novo Associado"}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        onOk={createAndEditAssociado}
        onCancel={() => setVisibleModal(false)}
        okText="SALVAR"
        cancelText="CANCELAR"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              marginTop: 0,
              width: 260,
              height: 160,
              borderRadius: 10,
              marginBottom: 25,
              marginBottom: 20,
              justifyContent: "center",
            }}
          >
            <img
              style={{
                width: 160,
                marginLeft: 50,
                height: 160,
                borderRadius: 10,
                background: "#fff",
              }}
              src={photo.photo_url ? photo.photo_url : userPhoto}
            />
            <IconButton style={{ width: 50, height: 50, bottom: 15 }}>
              <label
                for="avatar"
                style={{
                  display: "flex",
                  width: 50,
                  height: 50,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <MdAddPhotoAlternate color="#000" />
                <input
                  id="avatar"
                  style={{ display: "none" }}
                  type="file"
                  accept="image/"
                  onChange={(file) => {
                    let photo = file.target.files[0];
                    photo.photo_url = URL.createObjectURL(file.target.files[0]);
                    setPhoto(photo);
                  }}
                />
              </label>
            </IconButton>
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <ViewInput style={{ width: "48%" }}>
              <p>Nome Completo*</p>
              <Input
                placeholder="nome"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>Comissão (%)*</p>
              <InputNumber
                placeholder="comissão"
                style={{ width: "100%" }}
                min={0}
                max={100}
                value={comission}
                formatter={(value) => `${value}%`}
                parser={(value) => value.replace("%", "")}
                onChange={(value) => setComission(value)}
              />
            </ViewInput>
            <ViewInput style={{ width: "100%" }}>
              <p>E-mail*</p>
              <Input
                placeholder="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>Telefone</p>
              <InputTel
                placeholder="telefone"
                mask="(99) 99999-9999"
                value={phone_number}
                onChange={(e) =>
                  setPhone_number(e.target.value.replace(/[^0-9]/g, ""))
                }
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>{id ? "Alterar Senha" : "Senha*"}</p>
              <Input.Password
                placeholder="nova senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>CNPJ</p>
              <InputMask
                placeholder="cnpj"
                mask="99.999.999/9999-99"
                value={cnpj}
                onChange={(e) => setCnpj(e.target.value.replace(/[^0-9]/g, ""))}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>CPF</p>
              <InputMask
                placeholder="cpf"
                mask="999.999.999-99"
                value={cpf}
                onChange={(e) => setCpf(e.target.value.replace(/[^0-9]/g, ""))}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>Cidade</p>
              <Input
                placeholder="cidade"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </ViewInput>
            <ViewInput style={{ width: "48%" }}>
              <p>Estado (UF)</p>
              <Input
                value={state}
                placeholder="estado"
                maxLength={2}
                onChange={(e) => setState(e.target.value.toUpperCase())}
              />
            </ViewInput>
            <ViewInput style={{ width: "100%", marginTop: 5 }}>
              <p>Selecionar Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user_id || null}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser_id(value);
                }}
              >
                {users.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
          </div>
        </div>
      </Modal>
    </Container>
  );
}
